import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["className", "defaultWidth", "defaultHeight"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs as N, jsx as y } from "react/jsx-runtime";
import W, { useRef as o, useState as j, useEffect as O, useCallback as A, useMemo as q } from "react";
import { SanityImage as M } from "./SanityImage/SanityImage.js";
import { c as P } from "./clsx-OuTLNxxd.js";
import { i as k } from "./checks-C6AyTTQ0.js";
const T = "ResponsiveSanityImage-module_responsive-image-container__n2nqb",
  U = {
    responsiveImageContainer: T
  };
function G(r, n) {
  var e = o(null),
    u = o(null);
  u.current = n;
  var i = o(null);
  O(function () {
    c();
  });
  var c = A(function () {
    var t = i.current,
      a = u.current,
      f = t || (a ? a instanceof Element ? a : a.current : null);
    e.current && e.current.element === f && e.current.subscriber === r || (e.current && e.current.cleanup && e.current.cleanup(), e.current = {
      element: f,
      subscriber: r,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: f ? r(f) : void 0
    });
  }, [r]);
  return O(function () {
    return function () {
      e.current && e.current.cleanup && (e.current.cleanup(), e.current = null);
    };
  }, []), A(function (t) {
    i.current = t, c();
  }, [c]);
}
function _(r, n, e) {
  return r[n] ? r[n][0] ? r[n][0][e] :
  // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
  // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
  // @ts-ignore
  r[n][e] : n === "contentBoxSize" ? r.contentRect[e === "inlineSize" ? "width" : "height"] : void 0;
}
function J(r) {
  r === void 0 && (r = {});
  var n = r.onResize,
    e = o(void 0);
  e.current = n;
  var u = r.round || Math.round,
    i = o(),
    c = j({
      width: void 0,
      height: void 0
    }),
    t = c[0],
    a = c[1],
    f = o(!1);
  O(function () {
    return f.current = !1, function () {
      f.current = !0;
    };
  }, []);
  var l = o({
      width: void 0,
      height: void 0
    }),
    x = G(A(function (h) {
      return (!i.current || i.current.box !== r.box || i.current.round !== u) && (i.current = {
        box: r.box,
        round: u,
        instance: new ResizeObserver(function (b) {
          var m = b[0],
            R = r.box === "border-box" ? "borderBoxSize" : r.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize",
            S = _(m, R, "inlineSize"),
            v = _(m, R, "blockSize"),
            w = S ? u(S) : void 0,
            g = v ? u(v) : void 0;
          if (l.current.width !== w || l.current.height !== g) {
            var z = {
              width: w,
              height: g
            };
            l.current.width = w, l.current.height = g, e.current ? e.current(z) : f.current || a(z);
          }
        })
      }), i.current.instance.observe(h, {
        box: r.box
      }), function () {
        i.current && i.current.instance.unobserve(h);
      };
    }, [r.box, u]), r.ref);
  return q(function () {
    return {
      ref: x,
      width: t.width,
      height: t.height
    };
  }, [x, t.width, t.height]);
}
function K(r, n, e) {
  var u = this,
    i = o(null),
    c = o(0),
    t = o(null),
    a = o([]),
    f = o(),
    l = o(),
    x = o(r),
    h = o(!0);
  x.current = r;
  var b = typeof window < "u",
    m = !n && n !== 0 && b;
  if (typeof r != "function") throw new TypeError("Expected a function");
  n = +n || 0;
  var R = !!(e = e || {}).leading,
    S = !("trailing" in e) || !!e.trailing,
    v = ("maxWait" in e),
    w = "debounceOnServer" in e && !!e.debounceOnServer,
    g = v ? Math.max(+e.maxWait || 0, n) : null;
  O(function () {
    return h.current = !0, function () {
      h.current = !1;
    };
  }, []);
  var z = q(function () {
    var I = function (s) {
        var d = a.current,
          F = f.current;
        return a.current = f.current = null, c.current = s, l.current = x.current.apply(F, d);
      },
      p = function (s, d) {
        m && cancelAnimationFrame(t.current), t.current = m ? requestAnimationFrame(s) : setTimeout(s, d);
      },
      B = function (s) {
        if (!h.current) return !1;
        var d = s - i.current;
        return !i.current || d >= n || d < 0 || v && s - c.current >= g;
      },
      D = function (s) {
        return t.current = null, S && a.current ? I(s) : (a.current = f.current = null, l.current);
      },
      C = function s() {
        var d = Date.now();
        if (B(d)) return D(d);
        if (h.current) {
          var F = n - (d - i.current),
            H = v ? Math.min(F, g - (d - c.current)) : F;
          p(s, H);
        }
      },
      E = function () {
        if (b || w) {
          var s = Date.now(),
            d = B(s);
          if (a.current = [].slice.call(arguments), f.current = u, i.current = s, d) {
            if (!t.current && h.current) return c.current = i.current, p(C, n), R ? I(i.current) : l.current;
            if (v) return p(C, n), I(i.current);
          }
          return t.current || p(C, n), l.current;
        }
      };
    return E.cancel = function () {
      t.current && (m ? cancelAnimationFrame(t.current) : clearTimeout(t.current)), c.current = 0, a.current = i.current = f.current = t.current = null;
    }, E.isPending = function () {
      return !!t.current;
    }, E.flush = function () {
      return t.current ? D(Date.now()) : l.current;
    }, E;
  }, [R, v, n, g, S, m, b, w]);
  return z;
}
const L = r => function () {
    let n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return Math.abs(e - n) > r;
  },
  Q = (r, n, e) => {
    const u = L(e);
    return u(r.width, n.width) || u(r.height, n.height);
  },
  V = (r, n) => {
    const [e, u] = j({
        width: void 0,
        height: void 0
      }),
      i = K(t => {
        (!k(e.width) || !k(e.height) || Q(e, t, n || 200)) && u(t);
      }, r, {
        leading: !0
      }),
      {
        ref: c
      } = J({
        onResize: i
      });
    return _objectSpread({
      ref: c
    }, e);
  },
  X = _ref => {
    let {
        className: r,
        defaultWidth: n,
        defaultHeight: e
      } = _ref,
      u = _objectWithoutProperties(_ref, _excluded);
    const {
      ref: i,
      width: c,
      height: t
    } = V(1e3, 200);
    return /* @__PURE__ */N(W.Fragment, {
      children: [/* @__PURE__ */y(M, _objectSpread(_objectSpread({
        ref: i
      }, u), {}, {
        className: P([U.responsiveImageContainer, r]),
        width: c || n,
        height: t || e,
        forceRenderPreview: !c && !t
      })), /* @__PURE__ */y("noscript", {
        children: /* @__PURE__ */y(M, _objectSpread(_objectSpread({
          loading: void 0
        }, u), {}, {
          width: n,
          height: e
        }))
      })]
    });
  },
  ne = /* @__PURE__ */W.memo(X);
export { ne as R, V as u };